<template>
  <f7-page class="no-swipeback" login-screen @page:reinit id="login" >
    <a href="#login-main-content" class="skip-link">
      {{ $t('accessibility.skip_to_main_content') || 'Aller au contenu principal' }}
    </a>
    <div class="body bgLogin">
      <b-row class="h-100">
        <div class="loginPanel loginHeight">
          <main id="login-main-content" role="main" tabindex="-1">
          <div>
            <b-row class="panel-heading ajust text-center mb-2rem">
              <b-col cols="2"></b-col>
              <b-col cols="8" class="p-2">
                <h1 class="sr-only" v-if="!isUserConnected">{{ $t('loginPage.page_title') }}</h1>
                <span class="navbar-brand mr-0 w-80">
                  <img :src="imgVarsLong" alt="" class="heritage largescreen w-100">
                </span>
                <h2 class="panel-title" v-if="activationCode">
                  {{ $t('loginPage.sign_in_not_activated') }}
                </h2>
              </b-col>
              <b-col cols="2" class="p-0">
                <b-dropdown left class="no-back" toggle-class="border-0 m-md-2 z-5" variant="light">
                  <template slot="button-content">
                    <span class="sr-only">{{ $t('common.language_selector') || 'Sélecteur de langue' }}: {{ labelLanguage }}</span>
                    <img class="flag-nav d-none-min-1460px" :src="language === 'FR' ? logoFlagFR : logoFlagEN" alt="" aria-hidden="true"/>
                    <img class="flag-nav d-none-max-1459px" :src="language === 'FR' ? logoFlagFR : logoFlagEN" alt="" aria-hidden="true"/><span class="d-none-max-1459px mr-1" aria-hidden="true">{{ labelLanguage }}</span>
                  </template>
                  <b-dropdown-item v-for="option in langOptions" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
                    <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR" alt=""/>
                    <img class="flag-nav" v-else :src="logoFlagEN" alt=""/>
                    <span>{{option.text}}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
            <div @keyup.enter="quickLogin()">
              <h2 class="sr-only" v-if="!activationCode && !isUserConnected">{{ $t('loginPage.login_form_title') || 'Formulaire de connexion' }}</h2>
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login" id="Login"
                    inputType="text"
                    :inputLabel="$t('common.identifier')"
                    inputClass="inputLogin">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label for="password">{{ $t('common.pwd') }}</label>
                    <div class="d-flex">
                      <input v-model="credentials.Password"
                        id="password"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :type="passwordFieldType"
                        autocomplete="current-password" />
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleVisibility"
                        :aria-label="isPasswordFieldHidden ? $t('common.show_password') : $t('common.hide_password')"
                        role="button"
                        tabindex="0">
                      </i>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col v-if="withPassword" class="form-group">
                  <label for="passwordRepeat">{{ $t('common.conf_pwd') }}</label>
                  <div class="form-control passwordControl d-flex h-25px">
                    <input v-model="credentials.PasswordRepeat" class="border-0 w-100"
                      id="passwordRepeat"
                      :type="passwordFieldType"
                      :placeholder="loginpage_PasswordRepeat" />
                    <i class="icon icon-password"
                      :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                      @click="toggleVisibility"
                      :aria-label="isPasswordFieldHidden ? $t('common.show_password') : $t('common.hide_password')"
                      role="button"
                      tabindex="0">
                    </i>
                  </div>
                </b-col>
              </b-row>
            </div>

            <section aria-labelledby="login-actions" v-if="!isUserConnected">
              <h3 id="login-actions" class="sr-only">{{ $t('loginPage.login_actions_title') || 'Actions de connexion' }}</h3>
              <b-row class="loginButtons">
                <b-col cols="8" offset="2">
                  <b-button variant="primary" size="lg" id="submit-btn"
                    @click="authUser()">
                    {{ $t('loginPage.lgn_on_login_page') }}
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="loginButtons" v-if="flagCACP">
                <b-col cols="8" offset="2">
                  <b-button variant="secondary" size="lg"
                    @click="redirectSSO()">
                    {{ $t('loginPage.lgnsso_on_login_page') }}
                  </b-button>
                </b-col>
              </b-row>
            </section>
            <div class="pt-3 pb-1">
              <b-row>
                <b-col class="xs-12 text-center">
                  <b-col class="d-flex justify-content-center align-items-center">
                    <img class="logoStreammind" alt="" :src="logoStreammind"></img>
                    <span> {{ $t('common.copyright')}}</span>&nbsp;
                    <span>{{ version }}</span>
                  </b-col>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col class="xs-12 text-center">
                  <nav aria-label="Liens d'accessibilité et plan du site">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a href="/sitemap" class="text-decoration-underline text-muted" style="font-size: 11px;">
                          {{ $t('footer.sitemap') }}
                        </a>
                      </li>
                      <li class="list-inline-item">
                        <span class="text-muted" style="font-size: 11px;" aria-hidden="true">|</span>
                      </li>
                      <li class="list-inline-item">
                        <a href="/accessibilite" class="text-decoration-underline text-muted" style="font-size: 11px;" @click.prevent="navigateToAccessibility">
                          {{ $t('footer.accessibility_notice_compliant') }}
                        </a>
                      </li>
                    </ul>
                  </nav>
                </b-col>
              </b-row>
            </div>
          </div>
          </main>
        </div>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import _ from 'underscore'

import conf from '../../config/config.dev.js'
// import moment from 'moment-timezone'
import design from '@/design/design.json'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import CMAccountActivation from '@/popups/user/CMAccountActivation.vue'
import pageTitleMixin from '@/mixins/pageTitleMixin.js'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage, loadPageClearHistory} from '@/helpers/routing'

import StreammindImage from '@/assets/static/images/streammind-text-seul.png'
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'

export default {
  name: 'login',
  mixins: [pageTitleMixin],
  components: {
    'cm-account-activation-popup': CMAccountActivation,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    activationCodePassword: {
      default: 'notWithPassword',
      type: String
    }
  },
  data: () => {
    return {
      listEngineDown: [],
      activationCode: '',
      flagCACP: conf.visual === 'CACP',
      connected: false,
      credentials: {
        Biometrics: {
          Voice: 'string',
          Video: 'string',
          Fingerprint: 'string'
        },
        ConnectBy: false,
        Login: '',
        Password: '',
        PasswordRepeat: ''
      },
      defaultService: 'Direct Debit',
      defaultUrl: '/home/',
      design: design.login,
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      isLargeScreen: true,
      langOptions: [],
      language: '',
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      logoStreammind: StreammindImage,
      passwordFieldType: 'password',
      version: '',
      withPassword: false
    }
  },
  created () {
    this.defaultUrl = this.flagTOOLBOX ? '/homecarrousel/' : '/home/'
    this.language = this.$i18n.locale.toUpperCase()
    // Définir l'attribut lang du HTML en fonction de la langue actuelle
    document.documentElement.lang = this.$i18n.locale
    // Mettre à jour le titre de la page
    this.updatePageTitle(this.$t('loginPage.page_title'))
    this.langOptions = [
      { value: 'FR', text: this.$t('lang.french')},
      { value: 'EN', text: this.$t('lang.english')}
    ]
    this.$bus.$off('refresh-inbox-list-cache')
    this.activationCode = new URL(location.href).searchParams.get('activationCode')
    this.withPassword = new URL(location.href).searchParams.get('withPassword')
    if (this.withPassword === 'true') {
      this.withPassword = true
    } else {
      this.withPassword = false
    }
    if (!this.activationCode) {
      this.activationCode = ''
    }
    this.loginpage_Identifier = this.$i18n.t('common.enter_identifier')
    this.loginpage_PasswordRepeat = this.$i18n.t('common.conf_pwd')
    this.loginpage_UnvalidEmail = this.$i18n.t('errors.unvalid_email_adr')
    if (this.withPassword) {
      this.loginpage_Password = this.$i18n.t('common.new_pwd')
    } else {
      this.loginpage_Password = this.$i18n.t('common.enter_pwd')
    }
    if (this.$engine.firstOn().versionAPI) {
      this.version = 'Version ' + this.$engine.firstOn().versionAPI
    } else if (this.$engine.firstOn().common.network.state === 'online' || this.$engine.engines.filter(engine => engine?.common?.network?.state === 'online').length) {
      let that = this
      let engine = this.$engine.firstOn().common.network.state === 'online' ? this.$engine.firstOn() : this.$engine.engines.filter(engine => engine?.common?.network?.state === 'online')[0]
      engine.getApiVersion()
      .then(resp => {
        if (resp.data.version) {
          that.$engine.firstOn().versionAPI = resp.data.version
          if (that.$engine.firstOn().versionAPI) {
            that.version = 'Version ' + that.$engine.firstOn().versionAPI
          }
        }
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    }
  },
  mounted () {
    if (!this.isLargeScreen) {
      this.$$('.navbar').addClass('deleteNavBar')
    }
    /* TLV 24/08/2020 Si l'utilisateur a déjà une session ouverte et n'est pas en
    * OTP, on le redirige vers la page d'accueil par défaut */
    if (this.$engine.firstOn().auth.user.get().identifier !== '' && !location.href.includes('OTP')) {
      this.$$('.navbar').removeClass('deleteNavBar')
      this.$bus.$emit('login', true)
      loadPageClearHistory(this, {url: this.defaultUrl})
    }
  },
  computed: {
    isUserConnected () {
      return this.$engine.firstOn().auth.user.get().identifier !== ''
    },
    isPasswordFieldHidden () {
      return this.passwordFieldType === 'password'
    },
    imgVars () {
      return this.design.fontImage
    },
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    imgVarsShort () {
      return this.design.headbandLogoShort
    },
    labelLanguage () {
      let lang = this.language
      let langOpt = this.langOptions.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.$t('lang.french')
      if (langOpt.length) {
        label = langOpt[0].value
      }
      return label
    }
  },
  methods: {
    async loginAndConnect (creds) {
      let listEngineDownLocal = []
      let idSessionMaster = -1
      for (let i = 0; i < this.$engine.length; i++) {
        if (this.$engine.get(i)?.auth?.login) {
          try {
            await this.$engine.get(i).auth.login(creds)
            this.$engine.get(i).user.connectBy = 'login-password-capi'
            if(idSessionMaster == -1) {
              idSessionMaster = i
              this.$engine.default = idSessionMaster
            }
            this.$engine.get(i).common.network.setState(true)
            // changer default si premier est offline
            if (i !== this.$engine.engines.map(elem => elem.common.network.isDefault()).indexOf(true) && this.$engine.firstOn().common.network.state === 'offline') {
              this.$engine.setDefault(i)
            }
          } catch (error) {
            this.$engine.get(i).user.connectBy = ''
            listEngineDownLocal.push({
              host: this.$engine.get(i)?.common?.network?.info?.host || 'unknown',
              error: error
            })
          }
        }
      }

      if(listEngineDownLocal.length == this.$engine.length) {
        this.$f7.hidePreloader()
        if (this.activationCode.length > 0) {
          this.activateAccount(this.activationCode)
        } else {
          errorMessageAlert(listEngineDownLocal[0].error, this)
        }
      }
      else {
        this.connect()
        this.listEngineDown = listEngineDownLocal
      }
    },
    connect () {
      let defaultServiceId = parseInt(this.$engine.firstOn().services.getServiceIdByName(this.defaultService)) - 1
      let that = this
      this.$bus.emit('login', true)
      this.$bus.emit('service:change', this.defaultService)
      this.$bus.emit('refresh-cache-menu')
      this.$f7.hidePreloader()
      this.$$('.panel-overlay').css('z-index', '')
      this.$$('.deleteNavBar').removeClass('deleteNavBar')
      that.connected = true
      loadPageClearHistory(this, {url: (this.flagTOOLBOX ? '/homecarrousel/' : '/home/')})
    },
    authUser () {
      if (this.$$('.modal-in').length) {
        return
      }
      if (this.withPassword) {
        if (this.credentials.Login === '') {
          this.$f7.alert('Login missing', 'Error')
          return
        } else if (this.credentials.Password === '') {
          this.$f7.alert('Password missing', 'Error')
          return
        } else if (this.credentials.PasswordRepeat === '') {
          this.$f7.alert('Password confirm missing', 'Error')
          return
        } else if (this.credentials.Password !== this.credentials.PasswordRepeat) {
          this.$f7.alert('Passwords do not match', 'Error')
          return
        }
      }
      let that = this
      this.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
      const creds = _.clone(this.credentials)
      creds.ConnectBy = 'lpc'
      if (this.withPassword) {
        creds.WithPassword = '1'
      }
      this.loginAndConnect(creds)
      // treat listEngineDown
    },
    quickLogin () {
      if (!this.connected && this.credentials.Login.length !== 0 && this.credentials.Password.length !== 0 && !this.$$('.modal-in').length) {
        this.authUser()
      }
    },
    activateAccount (code) {
      this.$f7.showPreloader('Activating account')
      let that = this
      if (code !== '') {
        this.$engine.firstOn().auth.activate(code, this.withPassword, this.credentials.Password)
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              this.authUser()
            }
          }).catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
            // this.showModalActivationCode()
            // that.Dom7('.accountActivationInput2').val(code)
          })
      } else {
        that.$f7.hidePreloader()
        that.$f7.alert('Please enter a valid activation code', 'Incorrect')
        this.showModalActivationCode()
      }
    },
    redirectSSO () {
      window.location = 'loginSSO'
    },
    resetPassword () {
      this.$f7.popup('#cm-user-reset-password-true')
    },
    sendAnotherCode () {
      let that = this
      this.$f7.showPreloader('Sending')
      this.$engine.firstOn().auth.getNewActivationCode()
        .then(resp => {
          that.$f7.hidePreloader()
          that.$f7.alert('New activation code sent!', 'Ok')
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, this)
        })
    },
    showModalActivationCode () {
      let that = this
      that.$$('.blueConfirmationButtonActivationOK2').on('click')
      that.$f7.modal({
        title: 'Activate Account',
        text: 'Please enter your activation code',
        afterText: '<label for="activationCode">Activation code:</label><input id="activationCode" class="accountActivationInput2" type="text" aria-label="Activation code"><p class="blueConfirmationButtonActivationOK2">OK</p>',
        buttons: [
          {
            text: 'Cancel',
            onClick: function () {
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          },
          {
            text: 'Send new code',
            onClick: function () {
              that.sendAnotherCode()
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          }
        ]
      })
      that.$$('.blueConfirmationButtonActivationOK2').on('click', function (e) {
        that.$f7.closeModal()
        that.activateAccount(that.Dom7('.accountActivationInput2').val())
      })
    },
    toggleVisibility ($event) {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    handleClickSignIn () {
      let that = this
      // On se connecte via Google
      this.$gAuth.signIn()
      .then(GoogleUser => {
        var gu = GoogleUser.getBasicProfile()
        var FirstName = gu.getGivenName()
        var LastName = gu.getFamilyName()
        var Login = gu.getEmail()
        var Password = gu.getId()
        this.$engine.firstOn().user.connectBy = 'vue-google-oauth2'
        // est-ce qu'on est inscrit ? pour cela, on essait de se connecter
        that.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
        const creds = _.clone(that.credentials)
        creds.Login = Login
        creds.Password = Password
        creds.ConnectBy = 'vgo'
        this.$engine.firstOn().auth.login(creds)
        .then(resp => {
          // J'existe
          this.connect()
        }).catch(() => {
          // On fail do something
          that.$f7.hidePreloader()
          this.$engine.firstOn().auth.getLogin(Login, 'lpc')
          .then(() => {
            // Le compte existe en mode lpc.
            that.$f7.alert('The email sent by Google is already present in the database', 'Log in with your account')
          })
          .catch(err => {
            loadPage(that, {url: '/register/' + FirstName + '/' + LastName + '/' + Login + '/' + Password})
          })
        })
      })
      .catch(err => {
        // On fail do something
        if (err === false) {
          this.connect()
        }
      })
    },
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
        document.documentElement.lang = 'en'
      } else {
        this.$i18n.locale = 'fr'
        document.documentElement.lang = 'fr'
      }
      this.langOptions = [
        { value: 'FR', text: this.$t('lang.french')},
        { value: 'EN', text: this.$t('lang.english')}
      ]
    },
    navigateToAccessibility() {
      loadPage(this, { url: '/accessibilite/' })
    }
  }
}
</script>
